import logo from './logo.svg';
import './App.css';
import MainScreen from "./screens/MainScreen.js"

function App() {
  return (
    <div className="App">
      <MainScreen />
    </div>
  );
}

export default App;
